import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=a775cdaa&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=a775cdaa&prod&scoped=true&lang=css"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&id=a775cdaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a775cdaa",
  null
  
)

export default component.exports